module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPHBhdGggZmlsbD0iI2MxMjcyZCIgZD0iTTUxMiAwSDB2NTEyaDUxMnoiLz4KICA8cGF0aCBkPSJNMjU2IDE5MS40MTVMMjE4LjA1NCAzMDguMjFsOTkuMzMtNzIuMTU2aC0xMjIuNzdsOTkuMzMgNzIuMTU3eiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDA2MjMzIiBzdHJva2Utd2lkdGg9IjEyLjQ4NCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/ma.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/ma.svg
// module chunks = 0